import React from 'react';
import styles from './Private.module.css';

import privateAsset from '../../../assets/private-asset.png';

const Private = () => {

  return (
    <section className={styles.privateSection}>
      <h1 className={styles.privateTitle}>PRIVATE</h1>
        
      <img src={privateAsset} alt="Asset 1" className={styles.privateAsset} />
        <h2 className={styles.midText}>No more judging based on appearances. Get to 
know real people, discover real stories and  
share experiences.</h2>
          <h1 className={styles.bottomText}>We are not a catalogue of faces</h1>
    </section>
  );
};

export default Private;
